export default "__VITE_ASSET__CFoi9NN8__";